module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-reg-flows"
  }, [_c('div', {
    staticClass: "set-position",
    staticStyle: {
      "width": "100%",
      "max-width": "1200px",
      "margin": "0 auto"
    }
  }, [_c('h4', [_vm._v("供应商注册流程")]), _vm._v(" "), _c('hr', {
    attrs: {
      "id": "reg-flows-hr1"
    }
  }), _vm._v(" "), _c('hr', {
    attrs: {
      "id": "reg-flows-hr2"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "regflows"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": "static/imgs/registprogress.png",
      "alt": ""
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e39185a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reg-flows.vue
// module id = 137
// module chunks = 1 8